import { useLeague } from '../contexts/LeagueContext'
import { useT } from '@/i18n'
import { siteCoreMessages } from '@/i18n/catalogs/site-core'

// Rendered in place of the public site when a tenant is_active but its
// subscription is NOT live (subscription.is_live === false). Distinct from
// ClosedPage (which is the disabled-tenant state): this signals the league's
// billing has lapsed / not started, so the site is paused until they pay.
// Picks up the tenant's logo + theme so it still feels on-brand.

export default function SubscriptionInactivePage() {
  const { league } = useLeague()
  const t = useT(siteCoreMessages).widgets
  const name = league?.name ?? t.closed.nameFallback

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-gradient-to-b from-bg-secondary via-bg-primary to-bg-primary">
      <div className="text-center max-w-lg w-full">
        {league?.logo_url && (
          <img
            src={league.logo_url}
            alt={name}
            className="w-20 h-20 mx-auto mb-8 object-contain opacity-90"
          />
        )}

        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-secondary/40 text-xs uppercase tracking-[0.2em] text-text-secondary mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-primary" />
          {t.inactive.badge}
        </div>

        <h1 className="font-['Montserrat'] font-black text-4xl sm:text-5xl tracking-tight text-text-primary leading-tight">
          {name}
          <br />
          <span className="text-primary">{t.inactive.headline}</span>
        </h1>

        <p className="mt-6 text-text-secondary text-base leading-relaxed">
          {t.inactive.body}
        </p>

        <a
          href="/admin"
          className="mt-8 inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary text-bg-primary font-semibold hover:opacity-90 transition-opacity"
        >
          {t.inactive.adminLink}
        </a>

        <div className="mt-12 text-xs text-text-secondary/60">
          © {new Date().getFullYear()} {name}
        </div>
      </div>
    </div>
  )
}
